export default "__VITE_ASSET__5f39a087__"